import React from "react";
import { RecoilRoot } from "recoil";

import { PostArchivePage } from '../uiParts/post/PostArchivePage';

import { postState } from '../store/postState';

console.log("HospitalPostArchive");
const HospitalPostArchive = (props) => {
  const { staff_user, post_hospitals, posts } = props;

  // 編集の場合の初期値のセット
  const initializeState = ({ set }) => {
    set(postState, posts);
  };

  return (
    <RecoilRoot initializeState={initializeState}>
      <PostArchivePage staff_user={staff_user} hospitals={post_hospitals} />
    </RecoilRoot>
  );
};

export default HospitalPostArchive;